import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const names = ['María', 'Ana', 'Sofía', 'Julieta', 'Florencia', 'Carolina', 'Paula', 'Daniela', 'Romina', 'Agustina'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolledPastThreshold, setHasScrolledPastThreshold] = useState(false);
  const [currentNotification, setCurrentNotification] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const handleScroll = () => {
      if (hasScrolledPastThreshold) return;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollPosition + windowHeight >= documentHeight * 0.5) {
        setHasScrolledPastThreshold(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolledPastThreshold]);
  useEffect(() => {
    if (!hasScrolledPastThreshold) return;
    const generateNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentNotification({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    generateNotification();
    const interval = setInterval(() => {
      generateNotification();
    }, 10000);
    return () => clearInterval(interval);
  }, [hasScrolledPastThreshold]);
  if (!hasScrolledPastThreshold) return null;
  return <div className={`fixed bottom-6 left-6 z-50 transition-all duration-700 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-132">
      <div className="bg-white shadow-md border border-sand-200 p-4 pr-12 relative max-w-xs" data-id="element-133">
        <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-charcoal-300 hover:text-charcoal-500 transition-colors" aria-label="Cerrar" data-id="element-134">
          <XIcon className="w-3.5 h-3.5" data-id="element-135" />
        </button>
        <p className="text-sm text-charcoal-500 font-light leading-relaxed" data-id="element-136">
          <span className="font-medium text-charcoal-700" data-id="element-137">
            {currentNotification.name}
          </span>{' '}
          de {currentNotification.city} accedió a Florecer
        </p>
        <p className="text-xs text-charcoal-300 mt-1" data-id="element-138">
          hace {currentNotification.time}{' '}
          {currentNotification.time === 1 ? 'minuto' : 'minutos'}
        </p>
      </div>
    </div>;
}